// bookService.ts
// All book + review related API interactions

const BASE_URL = "https://latangelarogers.com/wp-json/tc/v1";

// ---------------------------
// Types
// ---------------------------

export interface BookPayload {
  title: string;
  content: string;
  author: string;
  isbn: string;
  year: string;
  pages: string;
  language: string;
  thumbnail?: string;
  meta?: any;
}

export interface Book extends BookPayload {
  id: number;
}

export interface ReviewPayload {
  book_id: number;
  title: string;
  content: string;
  rating: number;
}

export interface Review {
  id: number;
  author: string;
  rating: number;
  title: string;
  content: string;
  date: string;
  helpful: number;
}

// ---------------------------
// Internal authenticated fetch
// ---------------------------

async function authRequest(url: string, options: RequestInit = {}) {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found. User not logged in.");

  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {})
    }
  });

  if (!res.ok) {
    const msg = await res.text();
    throw new Error(msg || "Request failed");
  }

  return res.json();
}

// ---------------------------
// Book Functions
// ---------------------------

export async function getBook(bookId: number): Promise<Book | null> {
  try {
    const res = await fetch(`${BASE_URL}/book/${bookId}`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export async function addBook(payload: BookPayload) {
  return authRequest(`${BASE_URL}/book/add`, {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export async function editBook(bookId: number, payload: BookPayload) {
  return authRequest(`${BASE_URL}/book/${bookId}/edit`, {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export async function deleteBook(bookId: number) {
  return authRequest(`${BASE_URL}/book/${bookId}/delete`, {
    method: "DELETE"
  });
}

// ---------------------------
// Review Functions
// ---------------------------

export async function getReviews(bookId: number): Promise<Review[]> {
  try {
    const res = await fetch(`${BASE_URL}/book/${bookId}/reviews`);
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}

export async function addReview(payload: ReviewPayload) {
  return authRequest(`${BASE_URL}/review/add`, {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export async function markHelpful(reviewId: number) {
  return authRequest(`${BASE_URL}/review/helpful`, {
    method: "POST",
    body: JSON.stringify({ review_id: reviewId })
  });
}















// import { addBook, editBook, deleteBook, getBook, getReviews } from "./bookService";

// // add
// await addBook({
//   title: "New Book",
//   content: "Description...",
//   author: "Someone",
//   isbn: "xxx",
//   year: "2024",
//   pages: "200",
//   language: "English"
// });

// // edit
// await editBook(12, {
//   title: "Updated",
//   content: "...",
//   author: "Someone",
//   isbn: "123",
//   year: "2025",
//   pages: "199",
//   language: "English"
// });

// // delete
// await deleteBook(12);

// // load book
// const book = await getBook(12);

// // load reviews
// const reviews = await getReviews(12);